<template>
    <TransactionLog :section="0"></TransactionLog>
</template>

<script>
import TransactionLog from './TransactionLog.vue';
export default {
    components: {
        TransactionLog
    }
};
</script>